import style from './GoBackBtn.module.scss';
// import Arrow from './arrow.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { authResetError } from '../../../redux/Slices/authDataSlice';

const GoBackBtn = (
  // { link,
  //   externalLink
  // }
) => {
  // if (externalLink) {
  //   return (
  //     <a href={link}>
  //       <img src={Arrow} alt="Button" />
  //     </a>
  //   )
  // }
  // return (
  //   <Link to={link}>
  //     <img src={Arrow} alt="Button" />
  //   </Link>
  // )

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGoBackBtn = () => {
    navigate(-1)
    dispatch(authResetError())
  }

  return (
    <button
      className={style.GoBackBtn}
      onClick={() => handleGoBackBtn()}>
      {/* <img src={Arrow} alt="Button" /> */}
      <svg width="21.978027" height="40.000000" viewBox="0 0 21.978 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip108_777)">
          <path id="path" d="M4.20987 20.1292C4.20987 20.4505 4.28668 20.756 4.42023 20.9657L16.1628 39.3868C16.2775 39.567 16.4185 39.6554 16.5591 39.6554C16.7294 39.6554 16.8992 39.5248 17.0185 39.2716C17.2373 38.8096 17.209 38.1116 16.9552 37.7143L5.74615 20.1292L16.9552 2.54242C17.209 2.14502 17.2373 1.44788 17.0185 0.985046C16.8001 0.523071 16.4166 0.469849 16.1628 0.869873L4.42023 19.2927C4.28693 19.502 4.20987 19.8074 4.20987 20.1292Z" fill-rule="nonzero" fill="#000000" />
          <path id="path" d="M4.42023 20.9657L16.1628 39.3868C16.2775 39.567 16.4185 39.6554 16.5591 39.6554C16.7294 39.6554 16.8992 39.5248 17.0185 39.2716C17.2373 38.8096 17.209 38.1116 16.9552 37.7143L5.74615 20.1292L16.9552 2.54242C17.209 2.14502 17.2373 1.44788 17.0185 0.985046C16.8001 0.523071 16.4166 0.469849 16.1628 0.869873L4.42023 19.2927C4.28693 19.502 4.20987 19.8074 4.20987 20.1292C4.20987 20.4505 4.28668 20.756 4.42023 20.9657Z" stroke="#000000" />
        </g>
        <rect id="icons8-стрелка.svg" width="20.978022" height="39.000000" transform="translate(0.500000 0.500000)" stroke="#FFFFFF" />
        <defs>
          <clipPath id="clip108_777">
            <rect id="icons8-стрелка.svg" width="20.978022" height="39.000000" transform="translate(0.500000 0.500000)" fill="white" />
          </clipPath>
        </defs>
      </svg>

    </button>
  )
}

export default GoBackBtn;